import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';

@Component({
  selector: 'app-deductible-field',
  templateUrl: './deductible-field.component.html',
  styleUrls: ['./deductible-field.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class DeductibleFieldComponent {
  @Input('required') isRequired = false;

  form: FormGroup;
  constructor(private ctrlContainer: FormGroupDirective){};

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;

    if (this.isRequired) {
      this.form.addControl('deductible', new FormControl(null, Validators.required));
    } else {
      this.form.addControl('deductible', new FormControl(null));
    }
  }

  removeValue() {
    this.form.controls['deductible'].setValue(null);
  }

  ngOnDestroy(): void {
    this.form.removeControl('deductible');
  }
}
